import { TFunction } from "react-i18next";
import * as yup from "yup";

export const validateForm = (
  translate: TFunction<"translate", undefined>,
  email: string,
  callback: (error: yup.ValidationError[]) => void
) => {
  try {
    const schema = yup.object().shape({
      email: yup
        .string()
        .typeError(translate("pleaseEnterAValidEmail"))
        .email(translate("pleaseEnterAValidEmail"))
        .required(translate("pleaseEnterAValidEmail")),
    });

    schema.validateSync(
      {
        email,
      },
      { abortEarly: false }
    );
    callback([]);

    return true;
  } catch (err) {
    if (err instanceof yup.ValidationError) {
      callback(err.inner);
    }

    return false;
  }
};
